const T_PREFIX = "auth";

export const emailConfirmFailPopupTrns = {
  title: `${T_PREFIX}.email-confirm-fail-popup.title`,
  description: `${T_PREFIX}.email-confirm-fail-popup.description`,
  gotItButton: `${T_PREFIX}.email-confirm-fail-popup.got-it-btn`,
};
